export default __webpack_public_path__ + "static/media/ic_alarm_off_24px.14140691.svg";